'use es6';

import { catchError } from 'rxjs/operators/catchError';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { of } from 'rxjs/observable/of';
import { REQUESTED_MAB_END_EXPERIMENT } from '../actions/ActionTypes';
import { requestMABEndExperimentFailed, requestMABEndExperimentSucceeded } from '../actions/MABActions';
export default ((action$, _, {
  MABClient
}) => action$.ofType(REQUESTED_MAB_END_EXPERIMENT).pipe(mergeMap(({
  payload: {
    contentType,
    mabExperimentId,
    winnerId
  }
}) => MABClient.endExperiment(mabExperimentId, contentType, winnerId).pipe(mergeMap(mabEndTest => of(requestMABEndExperimentSucceeded({
  contentType,
  mabEndTest
}))), catchError(error => of(requestMABEndExperimentFailed(error, contentType)))))));